export interface PreloaderOptions {
    container: HTMLElement;
    lottieUrl: string;
    warningIcon?: string;
}

export class Preloader {

    public readonly element: HTMLDivElement;

    private _container: HTMLElement;

    constructor(options: PreloaderOptions) {
        options = e5.object.merge({
            warningIcon: "fas fa-warning"
        } as PreloaderOptions, options);

        this._container = options.container;

        this.element = document.createElement("div");
        this.element.className = "preloader base--gradient";
        this.element.setAttribute("data-mode", "default");
        this.element.innerHTML = `
        <div class="preloader__box preloader__box--default">
            <lottie-player class="preloader__icon" autoplay loop src="${options.lottieUrl}"></lottie-player>
            <div class="preloader__progress-bar">
                <div class="preloader__progress-bar-line"></div>
            </div>
        </div>
        <div class="preloader__box preloader__box--error">
            <div class="preloader__icon ${options.warningIcon}"></div>
            <div class="preloader__message"></div>
        </div>
        `;

        if (options.container) {
            options.container.appendChild(this.element);
        }
    }

    public showError(error: string): void {
        this.element.querySelector(".preloader__message").innerHTML = error;
        this.element.setAttribute("data-mode", "error");
    }

    public async show() {
        if (!this.element.parentNode) {
            this._container.appendChild(this.element);
        }

        this.element.classList.remove("e5-hidden");
        this.element.offsetWidth;

        this.element.classList.toggle("preloader--hidden", false);

        return new Promise<any>((resolve, reject) => {
            setTimeout(() => {
                resolve(true);
            }, 500);
        });
    }

    public async hide() {
        this.element.classList.toggle("preloader--hidden", true);

        return new Promise<any>((resolve, reject) => {
            setTimeout(() => {
                this.element.classList.add("e5-hidden");
                this.element.remove();
                resolve(true);
            }, 500);
        });
    }
}